var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { orderBy } from "lodash";
import Loading from "@irati/ui/src/Loading";
import authentication from "@irati/auth";
import { hangPromise } from "@irati/utils/promise";
import teamService from "@irati/identity/services/teams";
import { teamsKey } from "@irati/identity/services/queries/getTeams";
import listFormat from "@irati/utils/services/graph/utils/listFormat";
import TeamList from "../TeamList/TeamList";
import NoTeams from "../../../components/Teams/NoTeams/NoTeams";
var ViewTeams = /** @class */ (function (_super) {
    __extends(ViewTeams, _super);
    function ViewTeams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            teams: []
        };
        _this.setCurrentTeam = function (currentTeam) {
            _this.setState({ currentTeamId: currentTeam === null || currentTeam === void 0 ? void 0 : currentTeam.uuid });
        };
        return _this;
    }
    ViewTeams.prototype.componentDidMount = function () {
        var _this = this;
        this.listener = teamService
            .watchList(authentication.userTenant().uuid)
            .subscribe(function (data) {
            _this.setState({ load: null });
            var teams = listFormat(data.data[teamsKey]);
            _this.setState({ teams: orderBy(teams, "public_name", "asc") });
        });
    };
    ViewTeams.prototype.componentWillUnmount = function () {
        if (this.listener) {
            this.listener.unsubscribe();
        }
    };
    ViewTeams.prototype.render = function () {
        var _a = this.state, load = _a.load, teams = _a.teams, currentTeamId = _a.currentTeamId;
        var currentTeam = teams.find(function (t) { return t.uuid === currentTeamId; }) || null;
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Loading, { load: load }, teams.length <= 0 ? (React.createElement(NoTeams, null)) : (React.createElement(TeamList, { teams: teams, currentTeam: currentTeam, setCurrentTeam: this.setCurrentTeam }))))));
    };
    return ViewTeams;
}(Component));
export default ViewTeams;
